export default class CreateWorkTypeGroupError extends Error {

}
